import { connect } from 'react-redux'
import ContactTagAppliedDisplay from './ContactTagAppliedDisplay'

const stateToProps = () => ({})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(ContactTagAppliedDisplay)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactTagApplied/ContactTagAppliedDisplay.container.js